export const SET_LANDINGPAGE_DATA = 'SET_LANDINGPAGE_DATA';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const SET_PAGES = 'SET_PAGES';
export const SET_TEXT_BLOCKS = 'SET_TEXT_BLOCKS';
export const SET_CALENDARS = 'SET_CALENDARS';
export const SET_STAFF_LIST = 'SET_STAFF_LIST';

export const SET_NAVIGATION = 'SET_NAVIGATION';
export const SET_SCHEDULE = 'SET_SCHEDULE';
